import { createContext } from "react";

export const AbilityContext = createContext({});

// TODO: Fix this component
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props = any;

// export const Can = createContextualCan(AbilityContext.Consumer as Consumer<AnyAbility>);
export const Can = ({ children }: Props) => (
  <>{children}</>
);
